import React from 'react'
import {Helmet} from "react-helmet";

const About = () => {
    return(
        <div style={{color:'white', textAlign:'start', padding:'20px', paddingBottom:'100px'}}>
             <Helmet>
                <title>За нас</title>
            </Helmet>
            <h3>Добредојдовте на Читај!, најпаметниот агрегатор на македонски вести!</h3>
            <br/>
            <br/>
            Знаеме дека е важно да се остане информиран, но со денешната пренатрупаност со информации, навистина е тешко да се остане во тек со сѐ. Затоа ја создадовме оваа веб-страна за да ви олесниме да останете информирани за најновите вести и случувања во Македонија.
            <br/>
            <br/>
            Читај! собира вести од различни извори и ви ги прикажува во јасен и концизен формат. Разбираме дека времето е скапоцено, и затоа нудиме и функција за сумаризација, која ви овозможува брзо да ги прочитате најважните точки од секоја статија.
            <br/>
            <br/>
            Ја разбираме и важноста да се има избалансиран поглед на вестите, затоа имплементиравме функција за откривање политичка пристрасност, која ви помага да ја идентификувате пристрасноста на написите и да донесете сопствена проценка.
            <br/>
            <br/>
            Нашата веб-страна постојано се ажурира, така што можете да бидете сигурни дека ги добивате најновите вести како што се случуваат.
            <br/>
            <br/>
            <b>Читај! е сеуште во рана фаза на развој, секоја ваша забелешка е добредојдена!</b>
            <br/>
            <br/>
            Ви благодариме што го избравте Читај! како ваш извор за македонските вести. Посветени сме да ви обезбедиме точни, непристрасни и ажурни вести и се надеваме дека ќе уживате во користењето на нашата веб-страница.
        </div>
    )
}

export default About;